import React, {useEffect} from 'react';
import { Modal } from 'react-bootstrap';

import { Verification } from '../../global/Verification/Verification';

import classes from './VerificationModal.module.scss';
import { Api } from 'lb-store';

export const VerificationModal = ({ onSuccess, onCancel, ...props }) => {
  useEffect(() => {
    Api.User.Verification.CheckStatus().then((res) => {
      if (res.status && res.data?.status === 1) {
        onSuccess();
        onCancel();
      }
    });
  }, []);
  return (
    <Modal
      show
      centered
      size={'lg'}
      onHide={onCancel}
      contentClassName={classes.container}
      dialogClassName={classes.wrapper}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <Modal.Header
        closeButton
        closeVariant={'white'}
        className={classes.header}
      />
      <Verification
        onSuccess={() => {
          onSuccess();
          onCancel();
        }}
        {...props}
      />
    </Modal>
  );
};
